
import { BrowserRouter as Router,  Link,  Route, Routes } from "react-router-dom";
import { useState } from "react";
import ScrollToTop from "./components/ScrollToTop";
import Home from './home/Home';
import './App.css';
import './components/MegaMenu.css';
import MegaMenu from "./components/MegaMenu";
import ToteBag from "./home/ToteBag";
import PartyBag from "./home/PartyBag";
import SlingBag from "./home/SlingBag";
import AllProducts from "./home/AllProducts";
import ContactUsPage from "./home/ContactUsPage";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <MegaMenu />
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/totebag" element={<ToteBag/>} />
          <Route path="/partybag" element={<PartyBag/>} />
          <Route path="/slingbag" element={<SlingBag/>} />
          <Route path="/allproducts" element={<AllProducts />} />
          <Route path="/contactuspage" element={<ContactUsPage />} />
        </Routes> 
      </Router>
      <Footer/>
    </div>
  );
}

export default App;
